module.exports = __webpack_public_path__ + "static/10400556_21578142223_3317_n-0eef6338716241f8be1da410e6a4e6e0.jpg";